// extracted by mini-css-extract-plugin
export var image = "CollabSlide-module--image--fbd91";
export var wrapper = "CollabSlide-module--wrapper--a0ea8";